import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {

  constructor(
    private router:Router,
    private titleService: Title
    ) { }

  ngOnInit(): void {
    this.titleService.setTitle('MISK - Career');
  }

}

